import {Component, Inject, OnInit} from '@angular/core';
import {TestResultService} from '../../../services/api/result/test-result.service';
import {FormBuilder} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Test} from '../../../data/models/test/test';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-test-results-export-dialog',
  templateUrl: './test-results-export-dialog.component.html',
  styleUrls: ['./test-results-export-dialog.component.css']
})
export class TestResultsExportDialogComponent implements OnInit {

  test?: Test;
  minDate?: string;
  maxDate = formatDate(new Date(), 'yyyy-MM-dd', 'ru');

  exportForm = this.fb.group({
    fromDate: [''],
    toDate: [formatDate(new Date(), 'yyyy-MM-dd', 'ru')],
  });

  constructor(
    private testResultService: TestResultService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TestResultsExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      test: Test,
    },
  ) {
    this.test = data.test;
    if (this.test) {
      this.exportForm.controls.fromDate.setValue(this.test.createDate);
      this.minDate = this.test.createDate;
    }
  }

  ngOnInit(): void {
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.exportForm.valid) {

      const testId = this.test?.id;
      let fromDate = formatDate(this.exportForm.controls.fromDate.value, 'yyyy-MM-dd', 'ru');
      let toDate = formatDate(this.exportForm.controls.toDate.value, 'yyyy-MM-dd', 'ru');
      let fileName = 'Результаты';
      if (fromDate && toDate) {
        fileName += ` с ${fromDate} по ${toDate}`;
      }
      const downloadUrl = new URL(`/api/test-results/actions/export/${fileName}.xlsx`, window.location.href);
      const searchParams = downloadUrl.searchParams;

      if (testId) {
        downloadUrl.searchParams.append('testId', testId.toString());
      }
      if (fromDate !== undefined) {
        if (fromDate.length === 10) {
          fromDate += ' 00:00:00';
        }
        searchParams.append('fromDate', new Date(fromDate).toISOString());
      }
      if (toDate !== undefined) {
        if (toDate.length === 10) {
          toDate += ' 23:59:59';
        }
        searchParams.append('toDate', new Date(toDate).toISOString());
      }

      window.open(downloadUrl.toString(), '_blank');
      this.dialogRef.close();
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
